// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledCardBody = styled.div`
  padding: 1rem 2rem;
`
// #endregion

/**
 * Componente para renderizar el cuerpo de una tarjeta.
 *
 * @class
 * @example
 * <CardBody>...</CardBody>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const CardBody = ({ children, ...props }) => {
  return <StyledCardBody {...props}>{children}</StyledCardBody>
}

export default CardBody
